import { CropYear } from "pages/app/scenario-analysis/types/scenario";
import { cropYearHasAnyEntry } from "pages/app/scenario-analysis/utils/cropYearHelpers";

export type BaselineValidationErrorField = "crop" | "tillageId" | "residue";

export type BaselineValidationResult = {
  valid: boolean;
  /** False when not a single row has a crop — drives the step-1 empty-state error. */
  hasAnyCrop: boolean;
  errorsByYearId: Record<string, BaselineValidationErrorField[]>;
};

/**
 * Step-1 CTA validation: every row that holds any data needs a crop, and every
 * crop needs residue + tillage. Cover crop always has an explicit "None" default, so it
 * can never be missing. Fully blank rows are ignored (they are pruned before persisting).
 */
export const validateBaselineCropYears = (years: CropYear[]): BaselineValidationResult => {
  const errorsByYearId: Record<string, BaselineValidationErrorField[]> = {};
  let hasAnyCrop = false;

  years.forEach((year) => {
    const hasCrop = Boolean(year.crop?.trim());
    if (hasCrop) hasAnyCrop = true;

    const errors: BaselineValidationErrorField[] = [];

    if (!hasCrop && cropYearHasAnyEntry(year)) {
      errors.push("crop");
    }
    if (hasCrop && !year.tillageId) {
      errors.push("tillageId");
    }
    if (hasCrop && year.residue == null) {
      errors.push("residue");
    }

    if (errors.length > 0) {
      errorsByYearId[year.id] = errors;
    }
  });

  return {
    valid: hasAnyCrop && Object.keys(errorsByYearId).length === 0,
    hasAnyCrop,
    errorsByYearId,
  };
};
